export default {"src":"/_next/static/media/sconces.879b0585.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};